const specialChars = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
const digits = /^\d+$/;
const alphabet = /^[a-zA-Z\s]+$/;
const emailRegex =
  /^[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;

export const hasSpecialChars = (value: string) =>
  specialChars.test(value.trim());

export const hasDigits = (value: string) => digits.test(value.trim());

export const isAlphabetOnly = (value: string) => alphabet.test(value.trim());

export const isValidEmail = (value: string) => emailRegex.test(value.trim());

export const allValuesNonEmpty = (obj: {[s: string]: unknown}) => {
  return Object.values(obj).every(
    (value) => value !== null && value !== undefined && value !== ''
  );
};
